import { QRFC } from "./QRFC";

export class QDirRFCJSON extends QRFC {
  constructor() {
    super();
    this.fOrgName = null;
    this.fPath = null;
    this.fMode = null;
  }

  InitDirRFC(callbackObj, mode) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
    this.fMode = mode;
  }

  GetCallName() {
    return "qdirJSON";
  }

  SetParams(org, user, thePath) {
    this.fOrgName = org;
    this.fPath = thePath;
    this.AddParameter("dir", thePath);
    this.AddParameter("org", org);
    this.AddParameter("user", user);
  }

  DoTransactionComplete(response, callBackObj) {
    callBackObj.DirResult(response, this.fMode, this.fPath);
  }
}
